import { createBigDecimal } from '@0xtorch/big-decimal'
import { type Action, solana } from '@0xtorch/core'
import { nativeTokenDecimals } from '../../constants'
import { createSolanaAddressId } from '../../utils'
import type { GeneratorParameters } from '../types'

export const generateTxFee = ({
  transaction,
  accountIds,
  source,
}: GeneratorParameters & { readonly source: string }):
  | readonly Action[]
  | undefined => {
  if (
    transaction.meta === null ||
    transaction.transaction.message.accountKeys.length === 0
  ) {
    return undefined
  }
  const signer = transaction.transaction.message.accountKeys[0].pubkey
  const accountIdSet = new Set(accountIds)
  if (!accountIdSet.has(createSolanaAddressId({ address: signer }))) {
    return undefined
  }

  const amount = createBigDecimal(
    BigInt(transaction.meta.fee),
    nativeTokenDecimals,
  )
  return [
    {
      source,
      order: 0,
      type: 'transaction-fee',
      evidence: 'system-rule',
      timestamp: transaction.blockTime * 1000,
      comment: undefined,
      app: undefined,
      transfers: [
        {
          from: createSolanaAddressId({ address: signer }),
          to: undefined,
          price: undefined,
          asset: solana,
          amount,
          direction: 'out',
        },
      ],
    },
  ]
}
